import type { I18N } from '@vista-digital/i18n'
import type { Item } from '@vista-digital/ocapi-types/v1'
import type { OrderItemLineSelection } from '@vista-digital/occ-domain'
import { gtm } from '../../gtm.service'
import { Ecommerce, EcommerceDataLayer } from '../../models-gtm'
import { getConcessionCartShowtimeItems } from '../../utils/getConcessionCartShowtimeItems'
import { getConcessionEcommerceShowtimeItem } from '../../utils/getConcessionEcommerceShowtimeItem'
import type { CartDataGtm } from '../../utils/useCartData'

export class ConcessionsGtmEvents {
    public static selectItem(concession: Item, cartData: CartDataGtm, i18n: I18N) {
        const item = this.getConcessionEcommerceModel(concession, cartData, i18n)

        gtm.sendDataLayer(new EcommerceDataLayer('select_item', item))
    }

    public static addToCart(concessions: OrderItemLineSelection[], cartData: CartDataGtm, i18n: I18N) {
        const item = this.getConcessionEcommerceModelFromCartItem(concessions, cartData, i18n)

        gtm.sendDataLayer(new EcommerceDataLayer('add_to_cart', item))
    }

    public static removeFromCart(concessions: OrderItemLineSelection[], cartData: CartDataGtm, i18n: I18N) {
        const item = this.getConcessionEcommerceModelFromCartItem(concessions, cartData, i18n)

        gtm.sendDataLayer(new EcommerceDataLayer('remove_from_cart', item))
    }

    private static getConcessionEcommerceModelFromCartItem(
        concessions: OrderItemLineSelection[],
        cartData: CartDataGtm,
        i18n: I18N
    ): Ecommerce {
        const items = getConcessionCartShowtimeItems(concessions, cartData.film, cartData.showtime, cartData.site, i18n)

        return new Ecommerce(items)
    }

    private static getConcessionEcommerceModel(concession: Item, cartData: CartDataGtm, i18n: I18N): Ecommerce {
        const item = getConcessionEcommerceShowtimeItem(concession, cartData.showtime, cartData.site, i18n)

        return new Ecommerce([item])
    }
}
